import { __assign, __read } from "tslib";
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mark, markMotion } from '../../../../components';
import BarComponent from '../bar';
import BarValues from '../bar-values';
import { getBarColor } from '../../utils/bar.utils';
import { calculateMarkPosition, setMarkSize } from '../../utils/mark.utils';
var Bars = function (_a) {
    var bars = _a.bars, groupMode = _a.groupMode, stackMode = _a.stackMode, showValues = _a.showValues, valuesAutocolor = _a.valuesAutocolor, layout = _a.layout, activeKey = _a.activeKey, onBarMouseEnter = _a.onBarMouseEnter, onBarMouseLeave = _a.onBarMouseLeave, dataSeriesOffset = _a.dataSeriesOffset;
    var _b = __read(useState({ selector: [], key: null }), 2), activeBar = _b[0], setActiveBar = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(AnimatePresence, null, bars.map(function (_a) {
            var key = _a.key, selector = _a.selector, x = _a.x, y = _a.y, width = _a.width, height = _a.height, color = _a.color, value = _a.value, colorOutOfRange = _a.colorOutOfRange;
            return (React.createElement("g", { key: key, onMouseEnter: function (e) {
                    var markPosition = calculateMarkPosition({
                        layout: layout,
                        x: x,
                        y: y,
                        width: width,
                        height: height,
                        inPositiveCartesianQuadrant: value > 0,
                    });
                    setActiveBar({ key: key, selector: selector });
                    onBarMouseEnter(e, key, { selector: selector, color: color }, markPosition);
                }, onMouseLeave: function (e) {
                    setActiveBar({ selector: [], key: null });
                    onBarMouseLeave(e, key);
                } },
                React.createElement(BarComponent, { key: key, isActive: activeKey && selector.includes(activeKey), layout: layout, groupMode: groupMode, x: x, y: y, height: height, width: width, colorOutOfRange: colorOutOfRange, color: getBarColor({
                        activeBar: activeBar,
                        stackMode: stackMode,
                        barKey: key,
                        barSelector: selector,
                        color: color,
                        groupMode: groupMode,
                    }), dataSeriesOffset: dataSeriesOffset })));
        })),
        showValues && React.createElement(BarValues, { bars: bars, autocolor: valuesAutocolor }),
        bars.map(function (_a) {
            var key = _a.key, x = _a.x, y = _a.y, width = _a.width, height = _a.height, color = _a.color, value = _a.value;
            return (React.createElement(AnimatePresence, { key: key }, activeBar.key === key && (React.createElement(motion.g, __assign({}, markMotion, { pointerEvents: "all" }),
                React.createElement(Mark, __assign({}, calculateMarkPosition({
                    layout: layout,
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    inPositiveCartesianQuadrant: value > 0,
                }), setMarkSize({ layout: layout, width: width, height: height }), { color: color }))))));
        })));
};
export default Bars;
